<template>
  <wrapper>
    <div class="row center" v-if="your_exam_loading" style="padding-top:50px;">
      <pre-loader></pre-loader>
    </div>
    <fragment v-else>
      <div class="row">
        <h5>Coming Exam and Schedule</h5>
        <table>
          <thead>
            <tr>
              <th>No</th>
              <th>Subject</th>
              <th>Subject</th>
              <th>Date</th>
              <th>Time</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in your_exams.upcoming_exam" v-if="item.already_taken==false">
              <td>{{ index+1 }}</td>
              <td>{{ item.class.name }}</td>
              <td>{{ item.subject.name }}</td>
              <td>{{ item.date | moment("dddd, MMMM Do YYYY") }}</td>
              <td>From {{ item.start_time }} to {{ item.end_time }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row" style="margin-top:100px;">
        <div class="row">
          <div class="col s2">
            <h5>Test Result</h5>
          </div>
        </div>

        <table>
          <thead>
            <tr>
              <th>No</th>
              <th>Code</th>
              <th>Subject</th>
              <th>Mark</th>
              <th>Submitted Date</th>
              <th>Detail</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in your_exams.finished_exam">
              <td>{{ index+1 }}</td>
              <td>{{ item.exam.code }}</td>
              <td>{{ item.exam.subject.name }}</td>
              <td>{{ item.total_mark }}</td>
              <td>{{ item.created_at | moment("dddd, MMMM Do YYYY") }}</td>
              <td>
                <router-link
                  :to="'/exam-detail/'+item.exam.id"
                  class="btn blue darken-2"
                >View Details</router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </fragment>
  </wrapper>
</template>
<script>
export default {
  mounted() {
    this.$store.dispatch("get_your_exam");
  },
  computed: {
    your_exams() {
      return this.$store.getters.your_exams;
    },
    your_exam_loading() {
      return this.$store.getters.your_exam_loading;
    },
    classes() {
      return this.$store.state.class[0];
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/style/colors.scss";
h5 {
  color: white;
  background: $primaryColor;
  padding: 10px;
  width: 300px;
  border-radius: 150px;
  text-align: center;
  font-size: 20px;
}

.class_name {
  margin-left: 100px;
  background: cyan;
  color: black;
  border-radius: 0px;
}

table {
  width: 70%;
}

table td,
table th {
  border: 1px solid black;
  font-size: 16px;
}

table th {
  background: grey;
  color: white;
}
</style>